import React from 'react';
import styled from '@emotion/styled';
import ChevronIcon from './icons/ChevronIcon';

const Container = styled.div<{ active?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(99%);
  background: #57a8e6;
  padding-right: 0.75rem;
  height: 100%;
  width: auto;
  color: #ffffff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  align-items: center;
  padding-left: 0.2rem;
  line-height: 52px;
  z-index: 20;

  display: ${s => (s.active ? 'block' : 'none')};
`;

const LabelWrapper = styled.div<{ active?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    width: 13px;
    height: 8px;
    margin-top: 0.125rem;
    margin-left: 1rem;
    overflow: hidden;
    background: none;

    path {
      fill: #c8dff0;
    }

    display: ${s => (s.active ? 'inline-block' : 'none')};
    transform: rotate(-90deg);
  }
`;

const Label = styled.p`
  white-space: nowrap;
  margin: 0;
  padding: 0;
`;

interface Props {
  text: string;
  active: boolean;
  isParent?: boolean;
}

export const HoverLabel = (props: Props) => {
  return (
    <Container active={props.active} data-testid="hover-label-container">
      <LabelWrapper active={props.isParent}>
        <Label>{props.text}</Label>
        <ChevronIcon />
      </LabelWrapper>
    </Container>
  );
};

export default HoverLabel;
